import { nextTick, ref } from 'vue'

import { submitForm } from '@ds/components/Form'

import { useUserInformationStore } from '~/scopes/checkout/stores/userInformationStore'
import { focusFirstErrorFormField } from '~/scopes/checkout/utils/focusFirstErrorFormField'

type UserInformationsFormValues = {
  birthdate: string
  nationalId: string
  country: string
}

export function useUserInformationsValidation() {
  const userInformationStore = useUserInformationStore()

  const userInformationsValidated = ref(!userInformationStore.isFormRequired)
  const userInformationsValues = ref({
    birthdate: userInformationStore.birthdate,
    nationalId: userInformationStore.nationalId,
  })

  function onUserInformationsSubmit(values: UserInformationsFormValues) {
    userInformationsValidated.value = true
    userInformationsValues.value = {
      birthdate: values.birthdate,
      nationalId: values.nationalId,
    }
  }

  function onUserInformationsSubmitFailed(
    errors: Partial<Record<keyof UserInformationsFormValues, string>>,
  ) {
    userInformationsValidated.value = false

    focusFirstErrorFormField(errors)
  }

  async function validateUserInformations(): Promise<boolean> {
    if (!userInformationStore.isFormRequired) {
      return true
    }

    submitForm('user-informations-form')

    // We use the nextTick to have an updated userInformationsValidated since the submitForm is not synchronous
    await nextTick()

    return userInformationsValidated.value
  }

  return {
    userInformationsValues,
    onUserInformationsSubmit,
    onUserInformationsSubmitFailed,
    validateUserInformations,
  }
}
